<template>
    <div
        class="modal fade"
        id="exportacaoModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
    >
        <div
            class="modal-dialog modal-lg modal-dialog-centered"
            role="document"
        >
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">
                        {{dados ? dados.st_titulo : 'Layout de Exportação' }}
                    </h5>
                </div>
                <div class="modal-body">

                    <template v-if="dados">

                        <div v-if="is_contabil">
                            <az-input 
                                label="Plano de Contas Contábil"
                                type="select"
                                service="contabil_planos.index"
                                optionsData="id_contabil_plano"
                                optionsMode="aql"
                                required
                                :validate="validate"
                                v-model="id_contabil_plano" />
                        </div>

                        <div class="form-row" v-for="(filtro, icx) in lista_filtros" :key="icx">
                            <div class="col col-12 col-md-12 mt-1">
                                <template v-if="filtro.campo && filtro.campo.format && filtro.campo.format == 'dthr' && filtro.operacao && filtro.operacao == 'periodo' ">
                                    <small class="form-text text-muted text-nowrap text-truncate">
                                        {{exibirTitulo(filtro)}}
                                    </small>
                                    <az-periodo v-model="filtro.valorPeriodo" />
                                </template>

                                <template v-else>
                                    <az-input
                                        sizing="md"
                                        :icon="getIcon(filtro)"
                                        :type="(filtro.campo && filtro.campo.format && filtro.campo.format == 'currency') ? 'money' : ''"
                                        :label="exibirTitulo(filtro)"
                                        :validate="validate"
                                        v-model="filtro.valor">
                                    </az-input>
                                </template>
                            </div>
                        </div>

                    </template>

                    <div class="mt-1" v-if="lista_filtros && !lista_filtros.length">
                        <az-empty-state msg="Nenhum filtro identificado para o layout." icon="fas fa-file-csv" />
                    </div>

                    <div class="progress mt-1 mb-3" v-if="$store.state.loading">
                        <div class="indeterminate"> </div>
                    </div>

                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    <az-submit @click="gerar()">Gerar arquivo</az-submit>
                </div>


            </div>
        </div>
    </div>
</template>

<script>
import $ from "jquery";
import _ from "lodash";
import AzInput from '../shared/forms/AzInput.vue';
import AzSubmit from '../../components/util/AzSubmit.vue';
import AzPeriodo from '../shared/forms/AzPeriodo.vue';

export default {
    props: ["titulo"],
    
    data() {
        return {
            dados: null,
            validate: false, 
            id_contabil_plano: "", 
        };
    },

    components: {
        AzInput,
        AzSubmit,
        AzPeriodo,
    },

    computed: {

        is_contabil: function () { 
            return this.$route.path.slice(0,14) == '/contabilidade';
        },
        
        lista_filtros: function() { 
            if ( !this.dados )
                return [];

            return this.dados.st_filtros_json.filter(item => item.tipo == '1');
        }

    },
    
    methods: {
        
        executar: function(layout) {
            this.dados = layout;

             $("#exportacaoModal").modal("show");
        },

        exibirTitulo: function(filtro) {
            const campo = this.dados.st_campos_json.filter(item => item.nome == filtro.campo.search);
            if(campo && Array.isArray(campo) && campo.length > 0) {
                return campo[0].titulo;
            } else return filtro.campo.search;
        },

        getIcon: function(filtro) {
            var icon = 'fas fa-fw'

            switch (filtro.operacao) {
                case '=':
                    icon += ' fa-equals'
                    break;
                case '>=':
                    icon += ' fa-greater-than-equal'
                    break;
                case '<=':
                    icon += ' fa-less-than-equal'
                    break;
                case '!=':
                    icon += ' fa-not-equal'
                    break;
                case 'like':
                    icon += ' fa-percent'
                    break;
                default:
                    break;
            }

            return icon;
        },

        gerar: function() {
            this.$util.atualizar(this, { 
                service: 'exportacoes',
                func: 'gerar',
                dados: {
                    layout: { ...this.dados },
                    id_contabil_plano: this.id_contabil_plano, 
                },
                callback: (res) => { 
                    if(res.original) {
                        const fileName = _.camelCase(this.dados.st_titulo) + '.csv';

                        var dataStr = "data:text/plain;charset=utf-8," + encodeURIComponent(res.original);
                        var downloadAnchorNode = document.createElement('a');
                        downloadAnchorNode.setAttribute("href", dataStr);
                        downloadAnchorNode.setAttribute("download", fileName);
                        document.body.appendChild(downloadAnchorNode); 
                        downloadAnchorNode.click();
                        downloadAnchorNode.remove();
                    }
                },
            });
        }
    }
};
</script>

<style></style>
